import { BrowserRouter, Route, Routes } from 'react-router-dom';
import BlogList from './blog/BlogList';
import BlogPost from './blog/BlogPost';
import Layout from './components/Layout';
import IdareGuard from './idare/IdareGuard';
import IdareLogin from './idare/IdareLogin';
import { LanguageProvider } from './i18n/LanguageContext';
import HomePage from './pages/HomePage';
import PhotosPage from './pages/PhotosPage';
import './index.scss';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/photos" element={<PhotosPage />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Route>
          <Route path="/idare/login" element={<IdareLogin />} />
          <Route path="/idare/*" element={<IdareGuard />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
